// extracted by mini-css-extract-plugin
export default {"mainIcon":"FacebookShareLink_mainIcon__QJosd"};